// extracted by mini-css-extract-plugin
export var closed = "_gp-1";
export var resizer = "_gp-0";